// Dependencies
import React, { useState, useEffect, useCallback } from 'react';
import { useInView } from 'react-intersection-observer';
// Hooks
import useMount from '../hooks/useMount';
import useVideo from '../hooks/useVideo';
// Components
import NavBar from '../components/navbar';

const Video = ({ 
	wrapperClassName, 
	poster, 
	src, 
	autoPlay, 
	onLoad,
	videoLoaded
}) => {

  const [showPoster, setShowPoster] = useState(true);
  const [videoRef, play, pause] = useVideo();
	const [videoSrc, setVideoSrc] = useState("")

  const handlePlay = () => {
    play();
    setShowPoster(false);
  }

  const handlePause = () => {
    pause();

    //I've turned this off for a nicer experiance we have the video so lets just pause
    // setShowPoster(true);
  }

  const handleLoad = e => {
    onLoad(e);
    setShowPoster(false);
  }

  // IntersectionObserver hook...
  const [ref, inView] = useInView({
    threshold: 0.2
  });

  const handleVideoPlayer = useCallback(() => {
    if ("ontouchstart" in document.documentElement) {
      if (inView) {
        handlePlay();
      } else {
        handlePause();
      }
    }
  }, [inView]);

  useEffect(handleVideoPlayer, [inView]);

  const handlers = {
    onMouseEnter: !autoPlay ? handlePlay : null,
    onMouseLeave: !autoPlay ? handlePause : null
  }

	useEffect(() => {
		if (autoPlay) {
			setVideoSrc(src)
		}
	}, [autoPlay])

  return (
    <div className={wrapperClassName} {...handlers} ref={ref}>
      <video
        ref={videoRef}
        src={videoSrc}
				poster={poster}
        data-src={src}
        playsInline
        muted
        loop
        controls={false}
        autoPlay={autoPlay}
        onLoadedMetadata={handleLoad}
      />
      {showPoster && !videoLoaded && (
        <img src={poster} className="pabs" />
      )}
    </div>
  )
}

const DEFAULT_RATIO = 0.55;

// function hasAudio (video) {
//   return video.mozHasAudio ||
//   Boolean(video.webkitAudioDecodedByteCount) ||
//   Boolean(video.audioTracks && video.audioTracks.length);
// }

const Website = ({ 
	poster, 
	src, 
	websiteUrl, 
	isHighlight,
	setReveal
}) => {
	
	const ready = useMount()
	const [videoLoaded, setVideoLoaded] = useState(false)
  const [aspectRatio, setAspectRatio] = useState(false);

  const handleVideoLoad = e => {
    const { videoWidth, videoHeight } = e.target;
    if (videoWidth && videoHeight && isHighlight) {
      // setAspectRatio(videoHeight / videoWidth)
			setReveal(true)
    }
		setVideoLoaded(true)
  }

  return (
    <div>
      <NavBar url={websiteUrl} isLoading={false} isPlaying={aspectRatio} />
      <div className="prel inlb w100" style={{
        paddingTop: aspectRatio ? `${aspectRatio * 100}%` : `${DEFAULT_RATIO * 100}%`
      }}>
				{ready && (
					<Video 
						wrapperClassName="pabs fs ohide" 
						src={src} 
						poster={poster} 
						autoPlay={isHighlight} 
						onLoad={handleVideoLoad} 
						videoLoaded={videoLoaded}
					/>
				)}
      </div>
    </div>
  )
}

export default Website
